import { isWaitClose, jobGroup, nearCutoff } from './jobs';
import type { Job, JobGroup } from './types';

// Số liệu bảng phải của Mint-Job-1920 (Phân tích). Tính từ các dòng đang lọc; không có tiền.

export const DOCK_GROUPS: readonly JobGroup[] = ['Active', 'Standby', 'Released', 'Invoiced', 'Cancelled'];
export const DOCK_SALES = ['DAVID', 'PHILIP', 'TUANNT'] as const;

const SVC_LABEL: Record<string, string> = { FCL: 'Sea FCL', LCL: 'Sea LCL', TRUCK: 'Trucking', HQ: 'Hải quan' };

export interface DockStats {
  total: number;
  cut48: number;
  overdue: number;
  waitClose: number;
  groups: Array<{ group: JobGroup; n: number }>;
  services: Array<{ k: string; n: number }>;
  customers: Array<{ k: string; n: number }>;
  sales: Array<{ k: string; n: number; active: number }>;
}

const top = (m: Map<string, number>, limit: number) =>
  [...m.entries()].sort((a, b) => b[1] - a[1]).slice(0, limit).map(([k, n]) => ({ k, n }));

export function dockStats(rows: readonly Job[], now: string): DockStats {
  const svc = new Map<string, number>();
  const cus = new Map<string, number>();
  for (const j of rows) {
    const k = SVC_LABEL[j.shipment] ?? j.shipment;
    svc.set(k, (svc.get(k) ?? 0) + 1);
    cus.set(j.customer, (cus.get(j.customer) ?? 0) + 1);
  }
  return {
    total: rows.length,
    cut48: rows.filter((j) => nearCutoff(j, now)).length,
    overdue: rows.filter((j) => j.flags.includes('task')).length,
    waitClose: rows.filter(isWaitClose).length,
    groups: DOCK_GROUPS.map((group) => ({ group, n: rows.filter((j) => jobGroup(j.status, j.close) === group).length })),
    services: top(svc, 6),
    customers: top(cus, 5),
    sales: DOCK_SALES.map((k) => {
      const mine = rows.filter((j) => j.sale === k);
      return { k, n: mine.length, active: mine.filter((j) => jobGroup(j.status, j.close) === 'Active').length };
    }),
  };
}

export type SuggestKey = 'rod' | 'cut' | 'delayed' | 'standby';
export interface DockSuggest {
  key: SuggestKey;
  ids: string[];
}

/** Gợi ý theo danh sách đang xem: chỉ giữ nhóm có job; bấm = chọn sẵn các job đó. */
export function dockSuggests(rows: readonly Job[], now: string): DockSuggest[] {
  const open = (j: Job) => j.status !== 'Cancelled' && j.status !== 'RQ Cancel';
  const at = Date.parse(now);
  const sets: Array<[SuggestKey, Job[]]> = [
    ['rod', rows.filter((j) => j.flags.includes('rod'))],
    ['cut', rows.filter((j) => open(j) && nearCutoff(j, now))],
    ['delayed', rows.filter((j) => j.dir === 'OB' && j.etd !== null && Date.parse(`${j.etd}T00:00+07:00`) < at && ['BK Confirmed', 'BL Hold', 'BL Wait RLS'].includes(j.status))],
    ['standby', rows.filter((j) => j.status === 'BK Standby' && !!j.bookingNo)],
  ];
  return sets.filter(([, js]) => js.length > 0).map(([key, js]) => ({ key, ids: js.map((j) => j.id) }));
}
